import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const AccountStatusUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  status, onStatusChange, statusError, setStatusError, statusList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update account'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF
      type="text" name="status" label="Status"
      value={status} onChange={onStatusChange} optionList={statusList}
      error={statusError} setError={setStatusError}
      required={true}
    />
  </ModalFormUI>

export default AccountStatusUpdateModalUI
